enum PAYMENT_PLAN {
    BS = 'BS_Top',
    FIK = 'FIK_Top',
    MPS = 'MPS_Top'
}

export { PAYMENT_PLAN };
